// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__15FWy","bigColWidth":"Table_bigColWidth__ptXHl","biggerColWidth":"Table_biggerColWidth__23CQT","row":"Table_row__1ZG5T","col":"Table_col__1Xm9M"};